module.exports = __webpack_public_path__ + "img/mb-marker-default-128.1e7c7f63.png";